import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './CloudHero.css';

const CloudHero = () => {
  return (
    <Box className="cloud-hero">
      <div className="cloud-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="cloud-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="cloud-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Services
          </Typography>
          <Typography
            variant="h1"
            className="cloud-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            CLOUD SOLUTIONS
          </Typography>
          <Typography
            className="cloud-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Transform your business with scalable, secure, and efficient cloud solutions. 
            Our expert team delivers comprehensive cloud services, from migration and 
            infrastructure optimization to cloud-native development and managed services, 
            ensuring your business stays agile and competitive in the digital age.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default CloudHero; 